export const status = [
  'concluído', 
  'em andamento', 
  'não concluído'
];